import React from "react"
import styled from "styled-components"
import hero from "../../assets/images/cabin2.jpg"
import HeroContent from "./HeroContent.js"

export default function Hero() {
  return (
    <Wrapper>
      <div className="hero__img" style={{ backgroundImage: `url(${hero})` }} />
      <HeroContent />
    </Wrapper>
  )
}

const Wrapper = styled.section`
  position: relative;
  width: 100%;
  .hero__img {
    margin-top: 3rem;
    height: 608px;
    background-repeat: no-repeat;
    background-position: right center;
    background-size: 1160px;
  }
`
